import React from "react";
import "./Popup.css";

const PlotPopup = ({ isOpen, onClose, children }) => {
  const handleOutsideClick = (e) => {
    if (e.target.id === "plot-popup-background") {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div
      id="plot-popup-background"
      className="plot-popup-background"
      onClick={handleOutsideClick}
    >
      <div className="plot-popup-content">
        <button className="plot-popup-close-button" onClick={onClose}>
          Close
        </button>
        {children}
      </div>
    </div>
  );
};

export default PlotPopup;
